import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Check, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { http, PREMIUM_PRICE } from "@/lib/api";

const PERKS = [
  "Itinéraire détaillé heure par heure",
  "Adresses précises, coûts et conseils à chaque étape",
  "Comparatif transport complet (trajets, parking, gares)",
  "Activités et restaurants supplémentaires dans la zone",
  "Plan B en cas de pluie + liste d'affaires",
  "Lien d'accès unique, sans création de compte",
];

export const PremiumLock = ({ escapadeId, duration }) => {
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const pay = async () => {
    if (!accepted) return toast.error("Veuillez accepter les CGV pour continuer.");
    setLoading(true);
    try {
      const { data } = await http.post("/payments/checkout", { escapade_id: escapadeId, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch {
      toast.error("Impossible d'ouvrir le paiement. Réessayez.");
      setLoading(false);
    }
  };

  return (
    <div data-testid="premium-lock" className="relative rounded-2xl bg-[#0B131E] text-white p-8 grain overflow-hidden">
      <div className="relative">
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-500"><Lock className="w-4 h-4" /> Premium</div>
        <h3 className="mt-3 font-serif text-2xl font-semibold">Votre programme complet sur {duration} jour{duration > 1 ? "s" : ""}, prêt à l'emploi</h3>
        <ul className="mt-6 space-y-2.5">
          {PERKS.map((p) => (
            <li key={p} className="flex gap-2.5 text-sm text-gray-300"><Check className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />{p}</li>
          ))}
        </ul>
        <div className="mt-8 flex items-baseline gap-2">
          <span data-testid="premium-price" className="font-serif text-4xl font-bold">{PREMIUM_PRICE}</span>
          <span className="text-sm text-gray-400">paiement unique · TTC · cette escapade</span>
        </div>
        <label className="mt-5 flex items-start gap-2.5 text-xs text-gray-400 cursor-pointer">
          <input type="checkbox" data-testid="premium-cgv-checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} className="mt-0.5 accent-amber-600" />
          <span>J'accepte les <Link to="/cgv" target="_blank" className="underline hover:text-white">CGV</Link> et la <Link to="/confidentialite" target="_blank" className="underline hover:text-white">politique de confidentialité</Link>, et demande l'accès immédiat au contenu numérique en renonçant à mon droit de rétractation.</span>
        </label>
        <button data-testid="stripe-checkout-btn" onClick={pay} disabled={loading}
          className="mt-5 w-full inline-flex items-center justify-center gap-2 h-12 rounded-full bg-amber-600 hover:bg-amber-700 disabled:opacity-60 font-semibold transition-colors">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Débloquer l'itinéraire — {PREMIUM_PRICE}
        </button>
        <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-gray-500"><ShieldCheck className="w-3.5 h-3.5" /> Paiement sécurisé par Stripe · lien d'accès envoyé par email</p>
      </div>
    </div>
  );
};
